import request from '@/utils/request'

// 预览openid
export function previewOpenidUpdate(data) {
  return request({
    url: '/officialAccount/previewOpenidUpdate',
    method: 'post',
    data
  })
}
// 二次跳转创建
export function secondaryJumpcreate(data) {
  return request({
    url: '/periphery/secondaryJump/create',
    method: 'post',
    data
  })
}
// 二次跳转列表
export function secondaryJumplist(params = {}) {
  return request({
    url: '/periphery/secondaryJump/list',
    method: 'get',
    params
  })
}
// 二次跳转修改
export function secondaryJumpupdate(data) {
  return request({
    url: '/periphery/secondaryJump/update',
    method: 'post',
    data
  })
}
// 二次跳转删除
export function secondaryJumpdel(data) {
  return request({
    url: '/periphery/secondaryJump/del',
    method: 'post',
    data
  })
}
// 筛选事件
export function accountAccessexpireAccount(params = {}) {
  return request({
    url: '/spWorkWechat/accountAccess/expireAccount',
    method: 'get',
    params
  })
}
// 筛选事件
export function articleSettinguserReportList(params = {}) {
  return request({
    url: '/appletVideo/articleSetting/userReportList',
    method: 'get',
    params
  })
}

// 金币记录列表
export function adRedPacketCoinList(params = {}) {
  return request({
    url: '/packet/adRedPacket/coinList',
    method: 'get',
    params
  })
}
// 提现记录列表
export function adRedPacketWithdrawList(params = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawList',
    method: 'get',
    params
  })
}
// 提现配置列表
export function adRedPacketWithdrawConfigList(params = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawConfigList',
    method: 'get',
    params
  })
}
// 创建提现配置
export function adRedPacketWithdrawConfigCreate(data = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawConfigCreate',
    method: 'post',
    data
  })
}
// 更新提现配置
export function adRedPacketWithdrawConfigUpdate(data = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawConfigUpdate',
    method: 'post',
    data
  })
}
// 删除提现配置
export function adRedPacketWithdrawConfigDelete(data = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawConfigDelete',
    method: 'post',
    data
  })
}
// 设置/取消提现配置默认
export function adRedPacketWithdrawConfigSetDefault(data = {}) {
  return request({
    url: '/packet/adRedPacket/withdrawConfigSetDefault',
    method: 'post',
    data
  })
}
// 爱奇艺推广链接
export function iqiyipromotionlinklist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/list',
    method: 'get',
    params
  })
}
// 删除爱奇艺推广链接
export function iqiyipromotionlinkdel(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/del',
    method: 'post',
    data
  })
}
// 获取小程序访问次数
export function kiadwertwqw(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/default_a',
    method: 'post',
    data
  })
}
// 创建爱奇艺推广链接
export function iqiyipromotionlinkcreate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/create',
    method: 'post',
    data
  })
}
// 修改爱奇艺推广链接
export function iqiyipromotionlinkedit(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/update',
    method: 'post',
    data
  })
}
// 消息列表
export function delayedMsgList(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/list_delayed_msg',
    method: 'get',
    params
  })
}
// 修改链接
export function batchupdatedelayedmsgurl(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/batch_update_delayed_msg_url',
    method: 'post',
    data
  })
}
// 添加消息
export function createDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/create_delayed_msg',
    method: 'post',
    data
  })
}

// 修改消息
export function updDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/update_delayed_msg',
    method: 'post',
    data
  })
}
// 删除消息
export function delDelayedMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/del_delayed_msg',
    method: 'post',
    data
  })
}
// 删除消息
export function changeSwitchMsg(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/stop_delayed_msg',
    method: 'post',
    data
  })
}

// 待发素材列表
export function msgtemplatelist(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/msg_template/list',
    method: 'get',
    params
  })
}
// 创建模板
export function msgtemplatecreate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/msg_template/create',
    method: 'post',
    data
  })
}
// 修改模板
export function msgtemplateupdate(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/msg_template/update',
    method: 'post',
    data
  })
}
// 模板详情
export function msgtemplatedetail(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/msg_template/detail',
    method: 'get',
    params
  })
}
// 删除模板
export function msgtemplatedelete(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/msg_template/delete',
    method: 'post',
    data
  })
}
export function adDataSource(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/ad_data_source',
    method: 'get',
    params
  })
}
export function syncData(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link/sync_ad_data_source',
    method: 'get',
    params
  })
}
export function updateSecretKey(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_secret_key',
    method: 'post',
    data
  })
}
export function updateHkDefault(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_hk_default',
    method: 'post',
    data
  })
}
export function updateHkStatus(data) {
  return request({
    url: '/ad1/iqiyi/promotion_link/update_hk_status',
    method: 'post',
    data
  })
}
// 爱奇艺推广链接
export function iqiyipromotionlinklistv2(params) {
  return request({
    url: '/ad1/iqiyi/promotion_link_v2/list',
    method: 'get',
    params
  })
}
// 聊天记录列表
export function adRedPacketChatList(params = {}) {
  return request({
    url: '/packet/adRedPacket/chatList',
    method: 'get',
    params
  })
}
// 创建聊天记录（批量）
export function adRedPacketChatBatchCreate(data = {}) {
  return request({
    url: '/packet/adRedPacket/chatBatchCreate',
    method: 'post',
    data
  })
}
// 删除聊天记录（批量）
export function adRedPacketChatBatchDelete(data = {}) {
  return request({
    url: '/packet/adRedPacket/chatBatchDelete',
    method: 'post',
    data
  })
}
// 更新聊天记录
export function adRedPacketChatUpdate(data = {}) {
  return request({
    url: '/packet/adRedPacket/chatUpdate',
    method: 'post',
    data
  })
}
